import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a8495ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "img-preview-btn"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_3 = { class: "images" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hmd_empty_link = _resolveComponent("hmd-empty-link")!
  const _directive_viewer = _resolveDirective("viewer")!

  return (_ctx.canPreview)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_hmd_empty_link, { onClick: _ctx.show }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.url,
            width: "0",
            height: "0",
            style: {"display":"none"}
          }, null, 8, _hoisted_4)
        ])), [
          [_directive_viewer, { movable: false }]
        ])
      ]))
    : _createCommentVNode("", true)
}